import React from 'react';
import {
  Card,
  CardMedia,
  CardActions,
  CardContent,
  Grid,
  Typography,
  Divider,
  Box,
} from '@mui/material';

import { CtaProps } from '../atoms';
import { theme } from '../utils/theme';
import RootineButton from './RootineButton';

export interface ImageCardProps {
  image: string;
  alttext: string;
  title: string;
  variant: 'fullImage' | 'halfImage';
  description?: string;
  cta?: CtaProps;
  content?: JSX.Element;
}

export const ImageCard = (props: ImageCardProps) => {
  return (
    <>
      {props.variant === 'halfImage' && (
        <Card
          sx={{
            borderRadius: 0,
            height: 400,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            [theme.breakpoints.down('sm')]: {
              height: 360,
            },
          }}
        >
          <Box>
            <CardMedia
              component="img"
              height="120"
              image={props.image}
              alt={props.alttext}
            />

            <CardContent>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography gutterBottom variant="medium" sx={{ fontSize: 20 }}>
                  {props.title}
                </Typography>
                {props.description && (
                  <Typography color="text.secondary" fontSize={16}>
                    {props.description}
                  </Typography>
                )}
              </Box>
              {props.content && <Grid pt={5}>{props.content}</Grid>}
            </CardContent>
          </Box>

          <Box>
            {props.cta && (
              <Grid container justifyContent="center" sx={{ mb: 4 }}>
                <Grid item xs={12}>
                  <CardActions sx={{ px: 2 }}>
                    <RootineButton
                      variation="primary"
                      size="medium"
                      hideIcon
                      id={props.cta.btnId}
                      label={props.cta?.text || ''}
                      href={props.cta?.link}
                      onClick={props.cta?.func}
                      fullWidth
                    />
                  </CardActions>
                </Grid>
              </Grid>
            )}
          </Box>
        </Card>
      )}
      {props.variant === 'fullImage' && (
        <Card
          sx={{
            borderRadius: 0,
            background: `radial-gradient(113.39% 127.55% at 50% 49.85%, rgba(0, 0, 0, 0) 0%, #000000 100%, rgba(0, 0, 0, 0) 100%), url(${props.image})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minWidth: '100%',
            maxHeight: 800,
          }}
        >
          <CardContent>
            <Typography
              gutterBottom
              component="div"
              sx={{ fontSize: 12, color: 'white', pt: 3 }}
            >
              {props.title}
            </Typography>
            <Divider variant="inset" color="white" sx={{ margin: 0 }} />
            {props.description && (
              <Typography color="white" sx={{ fontSize: 36, fontWeight: 300 }}>
                {props.description}
              </Typography>
            )}
            {props.content && <Grid pt={5}>{props.content}</Grid>}
          </CardContent>
          {props.cta && (
            <CardActions sx={{ pb: 5, px: { xs: 3, sm: 30 } }}>
              <RootineButton
                variation="primary"
                size="medium"
                id={props.cta.btnId}
                label={props.cta?.text || ''}
                href={props.cta?.link}
                onClick={props.cta?.func}
                fullWidth
                hideIcon
              />
            </CardActions>
          )}
        </Card>
      )}
    </>
  );
};
